import { useHub } from "../lib/hubContent";
import { EditSectionButton } from "./HubEditor";
import SectionHeading from "./SectionHeading";
import Reveal from "./Reveal";

export default function AboutNelle() {
  const c = useHub().section("about");
  return (
    <section id="nelle" data-testid="about-section" className="relative bg-[#FAEEDC] text-[#7A3B12] py-24 md:py-32 overflow-hidden">
      <span className="absolute -top-10 right-0 font-display font-black text-[16rem] md:text-[24rem] leading-none text-orange-200/50 select-none pointer-events-none" aria-hidden="true">
        01
      </span>
      <EditSectionButton sectionKey="about" label="Edit about" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5 relative">
          <Reveal>
            <div className="relative max-w-sm mx-auto">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-28 h-7 bg-en-yellow/70 rotate-[-4deg] z-10" aria-hidden="true" />
              <figure className="relative bg-white p-4 pb-16 shadow-2xl rotate-[-3deg] hover:rotate-0 transition-transform duration-700">
                <img
                  src={c.portrait}
                  alt={c.portrait_alt}
                  data-testid="about-portrait"
                  className="w-full aspect-[4/5] object-cover object-[50%_25%]"
                  loading="lazy"
                />
                <figcaption className="absolute bottom-4 left-0 right-0 text-center font-hand text-2xl text-en-ink/80">
                  {c.portrait_caption}
                </figcaption>
              </figure>
              <p className="absolute -right-6 md:-right-14 top-8 font-hand text-2xl text-en-orange rotate-6 animate-floaty whitespace-pre-line" style={{ "--r": "6deg" }}>
                {c.hand_note}
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <SectionHeading
            eyebrow={c.eyebrow}
            title={<>{c.title_a} <span className="italic text-en-orange">{c.title_b}</span></>}
          />

          <Reveal delay={0.1}>
            <p className="text-base md:text-lg leading-relaxed text-orange-950/75 max-w-2xl mb-6">{c.para1}</p>
            <p className="text-base md:text-lg leading-relaxed text-orange-950/75 max-w-2xl mb-10">{c.para2}</p>
          </Reveal>

          <Reveal delay={0.18}>
            <div className="flex flex-wrap gap-2.5 mb-12">
              {(c.dimensions || []).map((d) => (
                <span key={d} className="rounded-full border border-orange-300 bg-white/70 px-4 py-1.5 font-mono text-[10px] tracking-[0.2em] uppercase text-orange-900/70">
                  {d}
                </span>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.24}>
            <blockquote data-testid="about-quote" className="relative border-l-4 border-en-orange pl-7 max-w-2xl">
              <p className="font-display italic text-2xl md:text-4xl leading-snug text-orange-950">
                "{c.quote}"
              </p>
              <cite className="not-italic font-hand text-xl md:text-2xl text-en-orange mt-4 block">{c.cite}</cite>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
